import React from 'react';
export function Header() {
  return <header className="w-full bg-gray-800 text-white py-4" data-id="element-20">
      <div className="container mx-auto px-4 md:px-8" data-id="element-21">
        <div className="flex justify-between items-center" data-id="element-22">
          <div data-id="element-23">
            <p className="text-sm" data-id="element-24">Professional Driver Safety Report</p>
          </div>
          <div className="flex items-center space-x-2" data-id="element-25">
            <div className="w-5 h-5 rounded-full overflow-hidden flex-shrink-0" data-id="element-26">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" data-id="element-27">
                <rect width="100" height="100" fill="#B22234" data-id="element-28" />
                <path d="M0,8.33h100 M0,16.67h100 M0,25h100 M0,33.33h100 M0,41.67h100 M0,50h100 M0,58.33h100 M0,66.67h100 M0,75h100 M0,83.33h100 M0,91.67h100" stroke="white" strokeWidth="6.25" data-id="element-29" />
                <rect width="40" height="54.17" fill="#3C3B6E" data-id="element-30" />
                <g fill="white" data-id="element-31">
                  {Array.from({
                  length: 9
                }, (_, row) => Array.from({
                  length: row % 2 ? 6 : 5
                }, (_, col) => <circle key={`${row}-${col}`} cx={row % 2 ? 4 + col * 6.67 : 7.33 + col * 6.67} cy={4 + row * 6} r="2" data-id="element-32" />))}
                </g>
              </svg>
            </div>
            <p className="text-sm font-medium" data-id="element-33">Trending in the US</p>
          </div>
        </div>
      </div>
    </header>;
}